<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cc5a6o/tc-custom/9781631955525.jpg?1741058684984" alt="This image is the cover for the book Firework Humans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Firework Humans
      </h1>
      <p class="bookDescription body article font2">
        <p>Firework Humans teaches readers how they can live an extraordinary life full of fireworks and steadily control their own orbit. Founder, CEO, Investor, and Homeschool Mom, Jessica Mead has spent two decades focused on how to spark entrepreneurial instincts in her employees and children. In Firework Humans, she offers a powerful and hopeful perspective on parenting, running a business, and amplifying one’s life. She introduces the Nine Entrepreneurial Instincts that she believes every human possesses and guides readers through the process of developing these instincts into behavioral traits. These nine instincts can be developed through applied education, enabling people to grow more curious, confident, courageous, and convicted with a Growth Mindset, to ultimately become—Firework Humans.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jessica Mead
      </h2>
      
      <p class="authorDescription body article">Jessica Mead is the Founder and CEO of Brandlync, a managing partner of Drivonic, and the co-founder of The Epek Companies and Mead Holdings Group. This all has a combined valuation toppling 100 million and a portfolio of angel investments that encompasses more than 20 companies. With offices in California, Washington, Indiana, Arizona, Brazil, the Netherlands, and India, Jessica is a non-traditional wife and mother who runs her business empire pretty much from wherever she chooses. She is seldom seen without her children as she homeschools them full-time: pioneering curriculum that is enviable by both traditional teachers and alternative education experts. She has been featured alongside Richard Branson, Shaquille O’Neil, and in publications like Forbes, Entrepreneur, and Yahoo Finance. Regularly, Jessica is asked to comment on the power of the female investing dollar, public school reform, homeschooling children while advancing one’s own career, and how to scale companies from the inside out without giving up control. With two amazing children, a 20-year marriage, a budding business portfolio, and an emerging women’s empowerment movement appropriately titled Still Orbiting, Jessica exudes business and life mastery. She resides in Encino, CA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26967da7